<template>
  <div>
    <div>
      <p class="ma-0 font-weight-medium">
        Previsão de gatilho
      </p>
      <p class="ma-0 mt-n1">
        {{ `${Helpers.formatarValor(detalhamento_categoria.previsao_gatilho)} dias` }}
        <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
      </p>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      width="500"
      content-class="bra-20"
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-card-title>
          <span>Previsão de gatilho</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <SysCategoriaMPPA
            v-model="categorias_selecionadas"
            label="Categorias onde a edição será feita"
            :qtde_visivel_selecionados="1"
            outlined
            clearable
            multiple
            :error-messages="getMensagensValidacao('categorias_selecionadas')"
          />

          <TextFieldFormatadorDeValor
            v-model="previsao_gatilho"
            outlined
            :max-digitos="0"
            inteiro
            label="Qtd. dias"
            suffix="dias"
            :error-messages="getMensagensValidacao('previsao_gatilho')"
            @focus="$event.target.select()"
            @keyup.enter="salvarPrevisaoGatilho()"
          />
        </v-card-text>

        <v-card-actions class="mt-n6">
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="salvarPrevisaoGatilho()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { required, minValue } from "vuelidate/lib/validators";
import { salvarPrevisaoGatilho } from "@/api/compras/MateriaPrima";
import { logout } from "@/helpers";
import {mapGetters} from "vuex";
import SysCategoriaMPPA from "@/components/utils/crud/SysCategoriaMPPAAutocomplete";

export default {
  name: "PrevisaoGatilho",
  components: {SysCategoriaMPPA, TextFieldFormatadorDeValor },
  props: {
    detalhamento_categoria: Object
  },
  data: () => ({
    dialog_ativo: false,
    categorias_selecionadas: [],
    previsao_gatilho: 0,
  }),
  validations: {
    categorias_selecionadas: {required},
    previsao_gatilho: {
      required,
      minValue: minValue(1),
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarGridCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'compraMateriaPrima/callbackAtualizarDetalhesCategoria',
    }),
  },
  watch: {
    dialog_ativo(valor) {
      if (valor) {
        this.categorias_selecionadas = [this.detalhamento_categoria.idcategoria];
        this.previsao_gatilho = this.detalhamento_categoria.previsao_gatilho;
      } else {
        setTimeout(() => {
          this.previsao_gatilho = 0;
          this.categorias_selecionadas = [];
          this.$v.$reset();
        }, 1000);
      }
    }
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v[campo].$dirty) return [];

      if ((this.$v[campo].$params.required !== undefined) && !this.$v[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v[campo].$params.minValue !== undefined) && !this.$v[campo].minValue) {
        return  ["Informe um valor maior."];
      }

      return [];
    },
    salvarPrevisaoGatilho() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        categorias: this.categorias_selecionadas,
        previsao_gatilho: parseInt(this.previsao_gatilho)
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarPrevisaoGatilho(parametros)
          .then(() => {
            this.dialog_ativo = false;
            this.$emit('novo-previsao-gatilho', this.previsao_gatilho)
            this.callbackAtualizarGridCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
